






































































import company from '@/components/company.vue'

export default {
    name: "headerHove",
    components: {company},
    props:['tabIndex'],
    data() {
        return {}
    }
}
